import Alerts from "../util/Alerts";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
} from "reactstrap";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { routes } from "../gen/General";
import { DatosContratante } from "../gen/DatosContratante";
import { DatosAsegurado } from "../vam/DatosAsegurado";
import axios from "axios";
import BlkFormik from "../coms/BlkFormik";
import JedaiDropImg from "../coms/BlkDropImg";
import { BlkField } from "../coms/BlkField";
import { EFI_MODULES, getRandomF, image_file_size } from "../util/General";
import { useSearchParam } from "../util/useLocation";
import { CltEjecutivos } from "./CltEjecutivos";
import { CltDirecciones } from "./CltDirecciones";
import { CltContacto } from "./CltContacto";
import { CltDocumento } from "./CltDocumento";
import { useUser } from "../custom-hooks/useUser";

export const Perfil = () => {
    const { moduleName: mod, isModuleGen, isModuleVam, ...user } = useUser();
    const alert = useRef();
    const [rnd, setRnd] = useState(getRandomF());
    const [cliente, setCliente] = useState({});

    function onSubmit(newValues, actions) {
        let foto = newValues.foto;
        let formData = new FormData();
        newValues.foto = undefined;
        formData.append("foto", foto);

        axios
            .post(routes.api + "/user/" + newValues.id, formData)
            .then(() => {
                alert.current.show_info("Guardado con éxito");
                setRnd(getRandomF());
            })
            .catch(error => {
                alert.current.handle_error(error);
            })
            .then(() => actions.setSubmitting(false));
    }

    return (
        <div className="content">
            <Alerts ref={alert} />
            <Card>
                <CardBody>
                    <CardTitle tag="h4">Datos del {isModuleVam ? "Asegurado" : "Contratante"}</CardTitle>
                    <div className="container-fluid">
                        <div className={"row"}>
                            {isModuleVam && <DatosAsegurado />}
                            {isModuleGen && <DatosContratante setCliente={setCliente} item={cliente} />}
                            <div className={"col-md-4"}>
                                <BlkFormik
                                    initialValues={user}
                                    onSubmit={onSubmit}
                                    enableReinitialize={true}
                                    validateOnChange={false}
                                >
                                    {({ values, submitForm, dirty }) => (
                                        <Row>
                                            <div className="form-group col-lg-12">
                                                <Label>Fotografía</Label>
                                                <BlkField
                                                    name="foto"
                                                    accept="image/*"
                                                    data={`${routes.api}/user/img/${values.id}?vrd=${rnd}`}
                                                    maxSize={image_file_size}
                                                    className="col-md-9 px-0"
                                                    component={JedaiDropImg}
                                                />
                                                <br />
                                                {dirty && (
                                                    <Button
                                                        color="primary"
                                                        className="mb-3"
                                                        onClick={() => submitForm()}
                                                    >
                                                        Guardar Foto
                                                    </Button>
                                                )}
                                            </div>
                                        </Row>
                                    )}
                                </BlkFormik>
                                <br />
                                <CambiarPassword />
                            </div>
                        </div>

                        <hr />

                        {mod === EFI_MODULES.GEN && cliente.cdCliente && (
                            <div className={"row"}>
                                <div className={"col-12"}>
                                    <h4 className={"text-primary card-title"}>Datos Adicionales</h4>
                                    <div>
                                        <CltEjecutivos clt={cliente} />
                                        <br />
                                        <CltContacto clt={cliente} />
                                        <br />
                                        <CltDirecciones clt={cliente} />
                                        <br />
                                        <CltDocumento clt={cliente} />
                                        <br />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export const CambiarPassword = () => {
    const iris = useSearchParam("iris");
    const [open, setOpen] = useState(!!iris);
    const user = useSelector(state => state.user);
    const alert = React.useRef(null);

    const onRequestAuth = event => {
        event.preventDefault();
        const data = new FormData(event.target);
        let body = {
            current: data.get("current"),
            passwd1: data.get("passwd1"),
            passwd2: data.get("passwd2"),
            id: user.id,
        };

        axios
            .post(routes.api + "/usuario/cambiar", body)
            .then(resp => {
                alert.current.show_info("Su contraseña se ha cambiado con éxito.");
                setOpen(false);
            })
            .catch(error => {
                alert.current.handle_error(error);
            });
    };
    return (
        <>
            <Alerts ref={alert} />
            <Button color="primary" onClick={() => setOpen(true)}>
                <i className={"fa fa-key"} /> Cambiar Contraseña
            </Button>
            <Modal className="text-center modal-xl" isOpen={open} toggle={() => setOpen(false)}>
                <ModalHeader className="justify-content-center title" tag="h4">
                    Cambio de Contraseña
                    {!iris && (
                        <button
                            type="button"
                            className="close"
                            title="cerrar"
                            onClick={() => setOpen(false)}
                            aria-label={"Close"}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    )}
                </ModalHeader>
                <Form onSubmit={onRequestAuth.bind(this)}>
                    <ModalBody className={"pt-2 mb-3"}>
                        <Row>
                            <Col md={3}></Col>
                            <Col md={6}>
                                <div>
                                    <InputGroup className={"input-group no-border form-control-lg"}>
                                        <InputGroupAddon className={"input-group-prepend"} addonType="prepend">
                                            <InputGroupText className={"input-group-text"}>
                                                <i className="now-ui-icons objects_key-25" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            className="form-control"
                                            type="password"
                                            placeholder="Contraseña actual"
                                            required
                                            name="current"
                                        />
                                    </InputGroup>

                                    <InputGroup className={"input-group no-border form-control-lg"}>
                                        <InputGroupAddon className={"input-group-prepend"} addonType="prepend">
                                            <InputGroupText className={"input-group-text"}>
                                                <i className="now-ui-icons ui-1_lock-circle-open" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            className="form-control"
                                            type="password"
                                            placeholder="Nueva Contraseña"
                                            required
                                            name="passwd1"
                                        />
                                    </InputGroup>

                                    <InputGroup className={"input-group no-border form-control-lg"}>
                                        <InputGroupAddon className={"input-group-prepend"} addonType="prepend">
                                            <InputGroupText className={"input-group-text"}>
                                                <i className="now-ui-icons ui-1_lock-circle-open" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                            className="form-control"
                                            type="password"
                                            placeholder="Verificar contraseña"
                                            required
                                            name="passwd2"
                                        />
                                    </InputGroup>
                                </div>
                                <div className="text-center">
                                    <Button color="primary" size="lg" className="mb-3">
                                        Guardar
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                </Form>
            </Modal>
        </>
    );
};
